import { useTranslation, Trans } from 'react-i18next';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Text from '@mui/material/Typography';
import Link from '@mui/material/Link';

import { DateTime } from 'luxon';

import { useUserQuery, useUserActions } from '../actions/UserActions';

const TOS_UPDATED_AT = DateTime.fromISO(process.env.REACT_APP_TOS_UPDATED_AT);

export default function TOSDialog() {
  const { t } = useTranslation();
  const { user } = useUserQuery();
  const { updateUser } = useUserActions();

  const enterprise = user?.organizations?.find((x) => x.type === 'enterprise');
  const notAccepted =
    TOS_UPDATED_AT.startOf('day') >
    DateTime.fromISO(user?.accepted_tos_at).startOf('day');

  const open =
    notAccepted && !enterprise && window.location.pathname !== '/2fa-verfiy';

  const handleClick = () => {
    updateUser({
      acceptedTosAt: DateTime.utc().toISO(),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      PaperProps={{
        sx: {
          width: '40rem',
          maxWidth: '100%',
        },
      }}
    >
      <DialogTitle>{t('Nya användarvillkor')}</DialogTitle>
      <DialogContent>
        <div>
          <Text>
            <Trans t={t}>
              Vi har uppdaterat våra användaravtal och vår integritetspolicy.{' '}
              <br />
              Klicka här för att läsa de uppdaterade villkoren:
              <Link
                href="https://app.klang.ai/info/terms.html"
                target="_blank"
                rel="noopener"
              >
                {' '}
                användarvillkor.
              </Link>{' '}
              <Link
                href="https://app.klang.ai/info/privacy.html"
                target="_blank"
                rel="noopener"
              >
                {' '}
                integritetspolicy
              </Link>{' '}
            </Trans>
          </Text>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClick} color="primary" variant="contained">
          {t('Godkänn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
